import { useEffect, useState } from 'react'
import { emitterProps, globalEmitter } from '../helpers/emitter'
import { type_GM_STATE } from '../../helpers'
import { openModal } from '../helpers/useModal'
import { HeartIcon } from '../icons/HeartIcon'
import { wishlistProviderService } from '../helpers/provider.service'

declare var GM_STATE: type_GM_STATE
declare var theme: { pageType: string }

const MOBILE_HEADER_BREAKPOINT: number = 1024

export function AccountHeader() {
  const [isHasList, setIsHasList] = useState(false)
  const [isMobile, setIsMobile] = useState(window.innerWidth < MOBILE_HEADER_BREAKPOINT)

  const handleClick = async () => {
    const rootUrlWithoutSlash = window.routes.rootUrlWithoutSlash
    const wishlistPagePath = '/account?view=wishlist'
    const loggedIn = await wishlistProviderService.isLoggedIn()

    if (loggedIn) {
      window.location.href = rootUrlWithoutSlash + wishlistPagePath
    } else {
      if (theme.pageType.includes('customers')) {
        const formSelectors = document.querySelectorAll<HTMLFormElement>('.js-form-account-custom')
        if (!formSelectors.length) {
          return
        }
        formSelectors.forEach(form => {
          const inputReturn = form.querySelector<HTMLInputElement>('input[name="return_to"]')
          if (inputReturn) {
            inputReturn.value = rootUrlWithoutSlash + wishlistPagePath
          } else {
            form.insertAdjacentHTML(
              'beforeend',
              `<input type="hidden" name="return_to" value="${rootUrlWithoutSlash}${wishlistPagePath}">`
            )
          }
        })
      } else {
        sessionStorage.setItem('returnTo', wishlistPagePath)
        openModal('account-slideout')
      }
    }
  }

  useEffect(() => {
    let isUnmounted = false

    const refreshWishlist = async () => {
      if (!GM_STATE.wishlist.enable) {
        if (!isUnmounted) {
          setIsHasList(false)
        }
        return []
      }

      const loggedIn = await wishlistProviderService.isLoggedIn()

      if (!loggedIn) {
        if (!isUnmounted) {
          wishlistProviderService.clearCachedLists()
          setIsHasList(false)
        }
        return []
      }

      if (!wishlistProviderService.isReady()) {
        return []
      }

      const wishlistLists = await wishlistProviderService.getLists()
      if (isUnmounted) {
        return []
      }

      globalEmitter.emit('fetchWishlist', wishlistLists)
      setIsHasList(wishlistLists.some((item) => item.items.length > 0))

      return wishlistLists
    }

    const handleWishlistChange = () => {
      refreshWishlist().then()
    }

    refreshWishlist().then()

    const detachReady = wishlistProviderService.onReady(handleWishlistChange)
    const detachProviderEvents = wishlistProviderService.subscribeToListChanges(handleWishlistChange)

    document.addEventListener(emitterProps.wishlist.add, handleWishlistChange)
    document.addEventListener(emitterProps.wishlist.remove, handleWishlistChange)

    return () => {
      isUnmounted = true
      detachReady()
      detachProviderEvents()
      document.removeEventListener(emitterProps.wishlist.add, handleWishlistChange)
      document.removeEventListener(emitterProps.wishlist.remove, handleWishlistChange)
    }
  }, [])

  useEffect(() => {
    const mediaQuery = window.matchMedia(`(max-width: ${MOBILE_HEADER_BREAKPOINT - 1}px)`)

    const syncIsMobile = (event?: MediaQueryListEvent) => {
      setIsMobile(event ? event.matches : mediaQuery.matches)
    }

    syncIsMobile()
    mediaQuery.addEventListener('change', syncIsMobile)

    return () => {
      mediaQuery.removeEventListener('change', syncIsMobile)
    }
  }, [])

  return (
    <div className='mega-menu__wishlist' tabIndex={0} onClick={handleClick}>
      {isMobile ? (
        <HeartIcon className={`Icon ${isHasList ? 'Icon__WishList' : ''}`} />
      ) : (
        'Wishlist'
      )}
      {!isMobile && <div className={`mega-menu__dot js-wishlist-dot${!isHasList ? ' hidden' : ''}`}></div>}
    </div>
  )
}
